import http from '../services/http';

import {
    CREATE_RESOURCE_PACK_ENDPOINT,
    UPDATE_RESOURCE_PACK_ENDPOINT,
    ALL_RESOURCE_PACKS_ENDPOINT,
    DELETE_RESOURCE_PACK_ENDPOINT,
    GET_RESOURCE_PACK_BY_CODE_ENDPOINT,
    generateEndpoint
} from '../services/endpoints';

export default (() => {

    const getAll = () => {

        return http.get(ALL_RESOURCE_PACKS_ENDPOINT);
    };

    const getByCode = (code) => {

        const endpoint = generateEndpoint(GET_RESOURCE_PACK_BY_CODE_ENDPOINT, { code });

        return http.get(endpoint);
    };

    const remove = (packId) => {

        var endpoint = generateEndpoint(DELETE_RESOURCE_PACK_ENDPOINT, { id: packId });

        return http.delete(endpoint);
    };

    const create = (options, progressUpdate) => {

        var formData = new FormData();

        formData.append('name', options.name);

        appendToFormData(options.files, formData, 'files');

        return http.post(CREATE_RESOURCE_PACK_ENDPOINT, formData, {

            progress: (progressEvent) => {

                progressUpdate(calculateUploadProgress(progressEvent));
            }
        });
    };

    const calculateUploadProgress = (progressEvent) => {

        return Math.round((progressEvent.loaded / progressEvent.total) * 100);
    };

    const appendToFormData = (files, formData, keyName) => {

        files.forEach((file, index) => {

            formData.append(`${ keyName }[${ index }]`, file);
        });
    };

    const update = (options, progressUpdate) => {

        var endpoint = generateEndpoint(UPDATE_RESOURCE_PACK_ENDPOINT, { id: options.id });

        var formData = new FormData();

        formData.append('id',   options.id);
        formData.append('name', options.name);

        const filesIdsToKeep = mapFilesToIds(getFilesToKeep(options.files));
        const filesToUpload  = getFilesToUpload(options.files);

        appendToFormData(filesIdsToKeep, formData, 'file_ids_to_keep');
        appendToFormData(filesToUpload,  formData, 'files');

        return http.post(endpoint, formData, {

            progress: (progressEvent) => {

                progressUpdate(calculateUploadProgress(progressEvent));
            }
        });
    };

    const mapFilesToIds = (files) => {

        return files.map((file) => {

            return file.id;
        });
    };

    const getFilesToUpload = (files) => {

        return files.filter((file) => {

            return file.selected_file && file.selected_file === true;
        });
    };

    const getFilesToKeep = (files) => {

        return files.filter((file) => {

            return !file.selected_file;
        });
    };

    return {
        getAll,
        update,
        getByCode,
        create,
        remove
    };

})();


// WEBPACK FOOTER //
// ./services/resourcePacks.js